import { http } from './http';

export function register(email, password) {
    return http.post('/personal/register', { email, password });
}

export function isNonePassword() {
    return http.get('/personal/isNonePassword');
}

export function changePassword(password, newPassword) {
    return http.post('/personal/changePassword', { password, newPassword });
}

export function setUserInfo(payload) {
    return http.patch('/personal/userinfo', payload);
}

export function getUserInfo() {
    return http.get('/personal/userinfo');
}

export function confirmEmail(email, code) {
    return http.post('/personal/confirm', { email, code });
}

export function login(email, password) {
    return http.post('/personal/login', { email, password });
}

export function resendCode(email) {
    return http.post('/personal/resend', { email });
}

export function sendEmailLink(payload) {
    return http.post('/personal/recover', payload);
}

export function validResetToken(token) {
    return http.get(`/personal/recover/${token}`);
}

export function resetPassword(token, payload) {
    return http.post(`/personal/recover/${token}`, payload);
}
